import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import SubscriptionPlan from "./subscription-plan";
import {setWorkspaceGraphSubscriptionPlans, workspaceGraphSelectors} from "../../system/workspace-graph-slice";

export function useSubscriptionPlan() {
    const dispatch = useDispatch();
    const plans = useSelector(workspaceGraphSelectors.subscriptionPlans);

    const getSubscriptionPlans = useCallback(async () => {
        const response = await new SubscriptionPlan().getCatalog();
        const items = response?.data || [];
        dispatch(setWorkspaceGraphSubscriptionPlans(items));
        return items;
    }, [dispatch]);

    return {plans, getSubscriptionPlans};
}
